export default __webpack_public_path__ + "static/media/campos.63b8a745.svg";